<template>
    <validation-provider :rules="rules"
                         v-slot="{ errors, classes }"
                         tag="div"
                         :mode="mode"
    >
        <uni-input-container label="Date de naissance"
                             for="input-date"
        >
            <datepicker :monday-first="true"
                        :language="fr"
                        v-model="value"
                        :class="classes"
                        @input="$emit('input', value)"
                        input-class="input-date"
                        id="input-date"
                        @click.native="scrollToBottom"
            >
            </datepicker>
            <span class="span-error">{{ errors[0] }}</span>
        </uni-input-container>
    </validation-provider>
</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import {fr} from 'vuejs-datepicker/dist/locale'
    import UniInputContainer from "./UniInputContainer";

    export default {
        name: "UniInputDate",
        components: {
            UniInputContainer,
            Datepicker
        },
        props: {
            id: String,
            type: {
                type: String,
                default: 'text',
            },
            placeholder: {
                type: String,
                default: '',
            },
            rules: String,
            mode: String,
        },
        data(){
            return{
                value: null,
                fr
            }
        },
        methods:{
            scrollToBottom(e){
                let el = e.target
                if((window.innerHeight - el.getBoundingClientRect().top) < 400)
                {
                    window.scrollBy(0, (400 - (window.innerHeight - el.getBoundingClientRect().top)))
                }
            }
        }
    }
</script>

<style lang="scss">
    .input-date{
        outline: none;
        border: 1px solid var(--color-grey-light-1);
        padding: 14px var(--s-xs);
        font-size: 1rem;
        line-height: 1rem;
        border-radius: var(--radius-default);
        width: 100%;
        transition: var(--transition-quick);
        display: block;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
        background: none;
        color: var(--color-accent);
        &.invalid{
            border: 1px solid var(--color-warning);
            &:focus, &:hover{
                border: 1px solid var(--color-warning);
            }
        }
    }

    .span-error{
        color: var(--color-warning-dark);
    }

    .vdp-datepicker{
        &:before{
            content:'';
            position:absolute;
            height: 24px;
            width: 24px;
            background: url('/icons/event.svg');
            margin: 12px 12px 0 0;
            right:0;
        }
    }

</style>
